<db-dialog-wrapper [dialog]="this" [width]="'819px'"[canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading" [fullScreen]="isMobile">
  <div class="db-remove-https db-remove-https-sm">

    <div class="db-remove-https-dialog__message">
      <div>
        <div class="db-remove-https-title">Remove SSL Certificate?</div>
        <div class="db-remove-https-desc" >Select the domain(s) from which you want to remove the free SSL certificate.</div>
         <div dbCustomScrollbar class="db-scroll">
          <form class="check_type" [formGroup]="removeFreeCertificateForm" [ngClass]="{'db-item1': allDomains.length === 1}">
            <ng-container *ngFor="let domain of allDomains; let i = index">
              <div>
                <label class="db-domains">
                  <div>
                <span class="db-fc-checkbox">
                  <input type="checkbox" (click)="addClass(i)" id="removeHttps_{{i}}" value="{{domain.id}}">
                  <span><i class="db-icon db-icon-check"></i></span>
                </span>
                    <div>
                      <p class="db-small">Domain</p>
                      <div class="db-domain-name">
                        <span>{{domain.name}}</span>
                      </div>
                    </div>

                  </div>
                </label>
              </div>
            </ng-container>
          </form>
        </div>
      </div>
    </div>

    <div class="db-remove-https-dialog__buttons">
      <a class="db-button" (click)="cancel()"  [ngClass]="{'db-button_disabled': loading}" ><span>{{'text_cancel' | dbText}}</span></a>
      <a class="db-button db-button_danger"  [ngClass]="{'db-button_disabled': !domainNameIds.length || !this.domainNameIds.length}" (click)="removeFreeCertificate()">
        <span>YES, REMOVE</span>
      </a>
    </div>

    <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
  </div>
</db-dialog-wrapper>

